import React,{useEffect,useState,useRef} from "react";
import DataTable, { createTheme } from "react-data-table-component";
import { getAxiosResponse, deleteAxiosResponse, postAxiosResponse, handleError } from "../../../services/authApiRoutes/APImethods";
import ProjectDetailModal from "../../project/ProjectDetailModal";
import APIUrls from "../../../services/APIUrls";
import { dateFormat, dateFormatAndStatus  } from "../../../services/Util";
import Constants from "../../../Constants";
import { Link, useParams } from "react-router-dom";
import { useSelector} from "react-redux";
import $ from 'jquery';
import Select, { NonceProvider } from 'react-select';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useTranslation } from "react-i18next";
import DateFormat from "../../../pages/DateFormat";

export default function Projects(props) {
  const { t } = useTranslation();
  const translate = t;
  const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
  const param = useParams();
  const filterRef = useRef(null);
  const selectRef = useRef(null);
  const [deleted,setDeleted] = useState(false)
  const [selectRighModal,setRightModal] = useState(false);
  const workspaceId = param.id;
  const [displayFilter, toggleDisplayFilter] = useState(false);
  const [projectDataLoader, toggleLoader] = useState(false);
  const [projectStatus, setProjectStatus] = useState("");
  const [projectDeliveryStatus, setProjectDeliveryStatus] = useState("");
  const [perPage, setPerPage] = useState(10);
  const [sort, setSort] = useState("");
  const [data, updateList] = useState([]);
  const [currentPage, updateCurrentPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [projectDetail,setProjectDetail] = useState([]);
  const [sortFocus, setsortFocus] = useState('');
  const paginationRef = useRef();
  const {refreshList,refreshProjectData,projectDeliveryStatusData}=props;

  const filterFunction = () =>{
    displayFilter ? toggleDisplayFilter(false) : toggleDisplayFilter(true);
    $('#activeId').toggleClass('clickActive')
    $('#activeId').attr('aria-expanded', function(index, attrValue) {
      return attrValue === 'true' ? 'false' : 'true';
    });
    $(document).mouseup(function(e) {
      var bannerCont = $('.btn-wrap');
      if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
        toggleDisplayFilter(false);
        $(".clickActive").trigger("focus");
        $('#activeId').removeClass('clickActive')
        $('#activeId').attr('aria-expanded', 'false');
      }
    });
  }
  useEffect(()=>{
    if(refreshProjectData){
      //For completed the status that needs to be sent is closed
          if(refreshProjectData.originalName==='completed'){
            setProjectStatus(`&simpleProjectStatus=closed`)
          }
          else{
            setProjectStatus(`&simpleProjectStatus=${refreshProjectData.originalName}`)
          }
    }
    if(projectDeliveryStatusData){
        setProjectDeliveryStatus(`&deliveryStatus=${projectDeliveryStatusData.originalName}`)
    }
  },[refreshProjectData ,projectDeliveryStatusData])

  useEffect(()=>{
    if(!refreshProjectData && !projectDeliveryStatusData ){
      fetchProjectData(currentPage);
    }
 },[projectStatus,projectDeliveryStatus,currentPage,sort])

 useEffect(()=>{
  if(projectDeliveryStatus  || projectStatus  ){
    fetchProjectData(currentPage);
  }
 },[projectDeliveryStatus,projectStatus])

      const handleEscFocus = (event) => {
        if (event.key === Constants.ESCAPE && event.target.ariaExpanded === 'true') {
          toggleDisplayFilter(false);
          $("#activeId").trigger("focus");
          $('#activeId').removeClass('clickActive')
          $('#activeId').attr('aria-expanded', false);
        }
      }
      const handleModalFocus = (event) => {
        if (event.key === Constants.TAB && !event.shiftKey
          && event.target.ariaExpanded === 'false'
          && $(event.target).is($('#filterBtn1 input:last'))
          ) {
          event.preventDefault();
          toggleDisplayFilter(false);
          $("#activeId").trigger("focus");
          $('#activeId').removeClass('clickActive')
          $('#activeId').attr('aria-expanded', 'false');
          $('#filterBtn1').css('display', 'none');
        } else if (event.key === Constants.ESCAPE && event.target.ariaExpanded === 'false') {
          event.preventDefault();
          toggleDisplayFilter(false);
          $("#activeId").trigger("focus");
          $('#activeId').removeClass('clickActive')
          $('#activeId').attr('aria-expanded', 'false');
          $('#filterBtn1').css('display', 'none');
        }
      }

  const {refreshProject}=props

  const status = [
    { label: "All", value: "" },
    { label: "Open", value: "&simpleProjectStatus=open" },
    { label: "In Creation", value: "&simpleProjectStatus=created" },
    { label: "In Quoting", value: "&simpleProjectStatus=inBidding" },
    { label: "In Translation", value: "&simpleProjectStatus=inTranslation" },
    { label: "In Review", value: "&simpleProjectStatus=inReview" },
    { label: "Completed", value: "&simpleProjectStatus=closed" },
  ];
  const deliveryStatus = [
    { label: "All", value: "" },
    { label: "On Track", value: "&deliveryStatus=ON_TRACK" },
    { label: "At Risk", value: "&deliveryStatus=AT_RISK" },
    { label: "Late", value: "&deliveryStatus=LATE" },
    { label: "Unknown", value: "&deliveryStatus=UNKNOWN" },
  ];
  const focusfirstElement = (e) => {
    if(e.target.nextSibling === null && e.key === "ArrowDown"){
      var firstChild = $(e.target).siblings('li').first();
      $(firstChild).trigger('focus');
    }
  }
  const iconComponent =() =>{
    return (
    <i className="arrow-icon">
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='12'
      height='8'
      viewBox='0 0 12 8'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.21967 0.815454C0.512563 0.519849 0.987437 0.519849 1.28033 0.815454L6 5.57882L10.7197 0.815454C11.0126 0.519849 11.4874 0.519849 11.7803 0.815454C12.0732 1.11106 12.0732 1.59033 11.7803 1.88593L6.53033 7.18455C6.23744 7.48015 5.76256 7.48015 5.46967 7.18455L0.21967 1.88593C-0.0732233 1.59033 -0.0732233 1.11106 0.21967 0.815454Z'
        fill='#076FA3'
      ></path>
    </svg>
  </i>
  );
  }
  const noDataFoundComponent = () => {
    return (
      <div role="rowgroup">
      <div role="row" className="no-data-display align-center">
       <div role="cell">
        <i className="nodata-icon"></i>
        <p>{Constants.NO_DATA_FOUND}</p>
      </div></div>
      </div>
    );
  };
  const StatusProp = {
    PaperProps: {
      style: {
        fontSize: "85.71429%",
        color: aaaSelected ? "white" : "#1C233C",
        background: aaaSelected ? "black" :"#FFF",
      },
      arialabel : 'list',
    },
  };
  const addStatusSelectAttrb = (e) =>{
    setTimeout(()=>{
      $('.MuiList-root').find('li').first().css("opacity",0);
      //$('.MuiList-root').find('li').first().css("height",0);
      $('.MuiList-root').find('li').first().css("padding",0);
      $('.MuiList-root').attr('aria-label','Status list');
    },200);
  }
  const handleStatusChange = (event) => {
    var selectedStatus = event.value;
    setProjectStatus(selectedStatus)
  };
  const handleDeliveryStatusChange = (event) =>{
    var selectedStatus = event.value;
    setProjectDeliveryStatus(selectedStatus);
  }
  
  $("#deleteYes").keypress(function() {
  });
  const confirmDelete = (id,name, e,row) =>{
       setTimeout(() => {
        $("#react-confirm-alert").attr({
          'aria-modal': 'true',
          'role': 'dialog',
          'aria-labelledby':"removeProject"
          });
          $("h1").attr({
          'id': 'removeProject',
         });
        }, 200);
        setTimeout(() => {
          $("#deleteNo").trigger("focus");
        }, 500);

    confirmAlert({
      title: 'Remove project from campaign',
      message: <p>{`Are you sure you want to remove the project ${ name} from this campaign ? `}</p> ,
      buttons: [
        {
          label: 'Yes',
          id:'deleteYes',
          onClick: () => postAxiosResponse(APIUrls.UPDATE_CAMPAIGN_PROJECT_LIST(workspaceId),data).then((res) => {
              refreshProject(res)
            if (res.data.status === "success") {
              fetchProjectData(currentPage)
              setDeleted(true)
              $('.lastdisable').trigger('focus');
            }
          })
          .catch((err) => {
            handleError(err);
          }),
          onKeyDown : (e) => {
            if(e.key === 'Tab'){
              if(e.shiftKey === true){
                e.preventDefault()
                $('#deleteNo').trigger('focus');
              }
            }
          }
        },
        {
          label: 'No',
          id:'deleteNo',
          onClick: () => {
            $(`#delete-icon-${id}`).trigger("focus");
          },
          onKeyDown : (e) => {
            if(e.key === 'Tab'){
                e.preventDefault()
                $('#deleteYes').trigger('focus');
            }
          }
        }
      ],
      closeOnEscape: true,
      closeOnClickOutside: true,
      
      overlayClassName: "delete_overlay",
      afterClose: () => {
        $(`#delete-icon-${id}`).trigger("focus");
      }
    });

    // var msg = `Do you want to delete the Project : ${name}`
   
    const data = {"projectIdsToRemove": [
      id
    ]}
   
  }
  const columns = [
    {
      id: "project.name",
      name: "Project Name",
      selector: (row) => row.name,
      sortable: true,
      cell: (row) => (
          <Link
            style={{
              color: aaaSelected ? "#FFF" : "#4067D6",
              fontWeight: 500,
              position: "relative",
            }}
            to={`/project/${row.id}`}
          >
            {row.name}
          </Link>
      ),
    },
    {
      id: "project.type",
      name: "Content Source",
      selector: (row) => row.projectContentTypeDisplay,
      sortable: true,
      cell: (row) => (
        <div aria-label={row.projectContentTypeDisplay}>
          {row.projectContentTypeDisplay}
        </div>
      ),
    },
    {
      id: "project.vendor",
      name: "Vendors",
      selector: (row) => row.vendor.name,
      sortable: true,
      cell: (row) => (
        <div aria-label={row.vendor.name}>
          {row.vendor.name}
        </div>
      ),
    },
    {
      id: "project.status",
      name: "Status",
      selector: (row) => row.status.display,
      sortable: true,
      cell: (row) => (
        <div tabIndex={row.status.display !== '' ? 0 : -1} aria-label={row.status.display} onClick={() =>
          rowClicked(row)} onKeyDown={(e) =>{if(e.key===Constants.ENTER) {rowClicked(row)}}}>
          {translate(`campaign_project_status.${row.status.code}`)}

        </div>
      ),
    },
    {
      id: "project.alert",
      name: "Alerts",
      selector: (row) => row.alertCount,
      cell: (row) => (
        <div className="flex-center aaa-alert-icon alert-text" aria-label={row.alertCount}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M8 6V9.33333M8 11.6667V12"
              stroke="#F04067"
              strokeLinecap="round"
            />
            <path
              d="M1.48801 12.6773L6.90001 2.03463C7.37534 1.0993 8.62668 1.0993 9.10134 2.03463L14.5127 12.6773C14.9667 13.5733 14.3627 14.6666 13.4107 14.6666H2.58868C1.63734 14.6666 1.03268 13.5733 1.48868 12.6773H1.48801Z"
              stroke="#F04067"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          {row.alertCount}
        </div>
      ),
    },
    {
      id: "projectQueryResult.dueDate",
      name: "Due Date",
      selector: (row) => row.dueDate,
      sortable: true,
      cell: (row) => (
        row.dueDate !== "" ? 
        <div>
            <DateFormat date={row.dueDate} />
        </div> : ""
      ),
    },
    {
      id: "project.amount",
      name: "Amount",
      selector: (row) => row.amount.value,
      sortable: true,
      cell: (row) => (
        <div aria-label={"amount "+row.amount.value+' $'}>
          {'$'+row.amount.value}
        </div>
      ),
    },
    {
      id: "project.action",
      name: "Action",
      selector: (row) => row,
      cell: (row) => (
        row?.userCanAlterProject && props?.editableByContextUser?
        <button aria-label="delete" className="delete-icon" onClick={(e)=> {
          confirmDelete(row.id,row.name, e,row)
        }} 
        id={`delete-icon-${row.id}`}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
        >
          <path
            d="M6.5 3H9.5C9.5 2.60218 9.34196 2.22064 9.06066 1.93934C8.77936 1.65804 8.39782 1.5 8 1.5C7.60218 1.5 7.22064 1.65804 6.93934 1.93934C6.65804 2.22064 6.5 2.60218 6.5 3ZM5.5 3C5.5 2.33696 5.76339 1.70107 6.23223 1.23223C6.70107 0.763392 7.33696 0.5 8 0.5C8.66304 0.5 9.29893 0.763392 9.76777 1.23223C10.2366 1.70107 10.5 2.33696 10.5 3H15.5C15.6326 3 15.7598 3.05268 15.8536 3.14645C15.9473 3.24021 16 3.36739 16 3.5C16 3.63261 15.9473 3.75979 15.8536 3.85355C15.7598 3.94732 15.6326 4 15.5 4H14.446L13.252 14.344C13.1676 15.0752 12.8173 15.7498 12.2679 16.2396C11.7184 16.7293 11.008 16.9999 10.272 17H5.728C4.99195 16.9999 4.28161 16.7293 3.73214 16.2396C3.18266 15.7498 2.8324 15.0752 2.748 14.344L1.554 4H0.5C0.367392 4 0.240215 3.94732 0.146447 3.85355C0.0526785 3.75979 0 3.63261 0 3.5C0 3.36739 0.0526785 3.24021 0.146447 3.14645C0.240215 3.05268 0.367392 3 0.5 3H5.5ZM3.741 14.23C3.79743 14.7174 4.03105 15.167 4.39742 15.4934C4.76379 15.8198 5.23735 16.0001 5.728 16H10.272C10.7627 16.0001 11.2362 15.8198 11.6026 15.4934C11.969 15.167 12.2026 14.7174 12.259 14.23L13.439 4H2.561L3.741 14.23ZM6.5 6.5C6.63261 6.5 6.75979 6.55268 6.85355 6.64645C6.94732 6.74021 7 6.86739 7 7V13C7 13.1326 6.94732 13.2598 6.85355 13.3536C6.75979 13.4473 6.63261 13.5 6.5 13.5C6.36739 13.5 6.24021 13.4473 6.14645 13.3536C6.05268 13.2598 6 13.1326 6 13V7C6 6.86739 6.05268 6.74021 6.14645 6.64645C6.24021 6.55268 6.36739 6.5 6.5 6.5ZM10 7C10 6.86739 9.94732 6.74021 9.85355 6.64645C9.75979 6.55268 9.63261 6.5 9.5 6.5C9.36739 6.5 9.24021 6.55268 9.14645 6.64645C9.05268 6.74021 9 6.86739 9 7V13C9 13.1326 9.05268 13.2598 9.14645 13.3536C9.24021 13.4473 9.36739 13.5 9.5 13.5C9.63261 13.5 9.75979 13.4473 9.85355 13.3536C9.94732 13.2598 10 13.1326 10 13V7Z"
            fill="#1D4ED8"
          />
        </svg>
      </button>:Constants.BLANK
      ),
    },
  ];

  const handleSort =  (column, sortDirection) => {
    var order = sortDirection.toUpperCase();
    var sortedColumn = column.id;
    var sortedString = `&sortOrder=${order}&sortColumn=${sortedColumn}`;
    $(".rdt_TableCol_Sortable[data-column-id='" + column.id + "']").attr({
      "aria-label": column.name,
      "aria-sort":
        order === Constants.DESC ? Constants.DESCENDING : Constants.ASCENDING,
    });
    setSort(sortedString);
  };


  const showRightModel = (state) => {
    const isStatusClicked = $(document.activeElement).parent().is('[id*="project.status"]');
    if (isStatusClicked) {
      $(document.activeElement).addClass('focusStatus');
    }
    setRightModal(state);
    document.body.classList.add("modal-open");
  };
  
  useEffect(()=>{
     if(refreshList !==null){
    fetchProjectData(currentPage);
     }
  },[refreshList])

  useEffect(() => {
    if ($('#activeId').attr('aria-expanded')==='true') {
      $(".local-filter").css("display", "block");
      $("#activeId").attr("aria-expanded", "true");
      //$("#filterBtn .wrap-dropdown .global-dropdown-block:first input").trigger("focus");
    } else {
      $(".local-filter").css("display", "none");
      $("#activeId").attr("aria-expanded", "false");
    }
  }, [displayFilter]);

  const rowClicked = (row) => {
    showRightModel(true);
    getAxiosResponse(
      APIUrls.PROJECT_LIST_DETAIL(row.id) )
      .then((res) => {
        if (res.data.code === 200) {
          setProjectDetail(res.data.data);
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };
  const handlePerRowsChange = (newPerPage, page) => {
     getAxiosResponse(
      APIUrls.PROJECT_LIST +
        `?workspaceId=${workspaceId}&page=${page}&pageSize=${newPerPage}${sort}${projectStatus}${projectDeliveryStatus}`
    )
      .then((res) => {
        if (res.data !== "") {
          updateList(res.data.data.result);
          setPerPage(newPerPage);
          setTimeout(function(){
            $('.datatable-block.project-table').find('nav.rdt_Pagination select').trigger('focus');
          }, 100);
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };
  const handlePageChange = (paging) => {
    updateCurrentPage(paging);
    // updatePrevPage(currentPage);
		if ($('#pagination-last-page').attr('aria-disabled')==="true") {
			paginationRef.current = $('#pagination-previous-page').attr('id');
		} else if ($('#pagination-first-page').attr('aria-disabled')==="true") {
			paginationRef.current = $('#pagination-next-page').attr('id');
		} else {
			paginationRef.current = document.activeElement.id;
		}

  };
  const fetchProjectData =  (page) => {
    toggleLoader(true);
     getAxiosResponse(
      APIUrls.PROJECT_LIST +
        `?workspaceId=${workspaceId}&page=${page}&pageSize=${perPage}${sort}${projectStatus}${projectDeliveryStatus}`
    )
      .then((res) => {
        if (res.data !== "") {
          updateList(res.data.data.result);
          setTotalRows(res.data.data.resultCount);

          setTimeout(() => {
            if(sortFocus){
                   $(".rdt_TableCol_Sortable[data-column-id='" + sortFocus + "']").trigger('focus');
                   setsortFocus('');
                 }
            if (paginationRef.current) {
                 $('#'+ paginationRef.current).trigger('focus');
                 paginationRef.current = '';
             }
           }, 300);

        }
      })
      .catch((err) => {
        handleError(err);
      });
    toggleLoader(false);
  };
	$(document).ready(function(){
    $(".rdt_Table .rdt_TableCol span").attr("aria-hidden","true"); 
    $(".rdt_TableCol .rdt_TableCol_Sortable[disabled]").attr("tabIndex","-1"); 
   })


  useEffect(() => {
    const body = document.querySelector('body');
    
    const handleClickOutside = (event) => {
      if (
        filterRef.current &&
        !filterRef.current.contains(event.target) &&
        event.target !== body
      ) {
        const list = event.target.classList.contains("MuiButtonBase-root");
        const list1 = event.target.classList.contains("MuiTypography-root")
        const list2 = event.target.classList.contains("MuiSvgIcon-root");
        const box = event.target.classList.contains("MuiBackdrop-root");
        const button = event.target.classList.contains("dashboard-btn")
        const paperroot = event.target.classList.contains("MuiPaper-root")
        const svgItem = event.target.closest('.MuiSvgIcon-root');
        const dashboard = event.target.classList.contains("dashboard-content")
        if (!list && !list1 && !list2 && !svgItem && !box && !dashboard && !button && !paperroot) {
          $( "#filterBtn1" ).removeClass( "show-flex" )
        }
      }
    };
    const handleEscape = (event) => {
      if (
        event.key === "Escape" &&
        filterRef?.current?.contains(event.target)
      ) {
        toggleDisplayFilter(false);
      }
      if (
        event.target.classList.contains("dashboard-btn") &&
        event.key === "Tab"
      ) {
        $("#activeId2").trigger("blur");
        // $('.dashboard-btn').trigger('focus')
      }
    };
    document.addEventListener("click", handleClickOutside, true);
     document.addEventListener("focus", handleClickOutside, true);
    document.addEventListener("keydown", handleEscape, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
      document.addEventListener("focus", handleClickOutside, false);
      document.addEventListener("keydown", handleEscape, false);
    };
  }, [filterRef,selectRef]);
  
  return (
    <div className="listing-content">
      <div className="campaign_details-projects campaign-form">
        <div className="projects-heading">
          <h5>{translate("campaign_page.campaign_projects") }</h5>
          <div className="filter btn-wrap" id="filter">
            <button
              id="activeId"
              className="dashboard-btn"
              onClick={filterFunction}
              aria-expanded="false"
              onKeyDown={(e) => handleEscFocus(e)}>
              <span className="filter-icon">
                <svg
                  width="19"
                  height="14"
                  viewBox="0 0 19 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.5627 4.00922H7.56233C7.32684 4.00922 7.125 3.64384 7.125 3.21755C7.125 2.79127 7.32684 2.42589 7.56233 2.42589H18.5627C18.7982 2.42589 19 2.79127 19 3.21755C19 3.64384 18.7982 4.00922 18.5627 4.00922Z"
                    fill="#1D4ED8"
                  ></path>
                  <path
                    d="M2.99075 3.649H0.607496C0.280383 3.649 0 3.36861 0 3.0415C0 2.71439 0.280383 2.43401 0.607496 2.43401H2.99075C3.31786 2.43401 3.59824 2.71439 3.59824 3.0415C3.59824 3.36861 3.36459 3.649 2.99075 3.649Z"
                    fill="#1D4ED8"
                  ></path>
                  <path
                    d="M5.37429 6.03238C3.73873 6.03238 2.38354 4.6772 2.38354 3.04164C2.38354 1.40607 3.73873 0.0508881 5.37429 0.0508881C7.00986 0.0508881 8.36504 1.40607 8.36504 3.04164C8.36504 4.6772 7.05659 6.03238 5.37429 6.03238ZM5.37429 1.26588C4.39295 1.26588 3.59854 2.0603 3.59854 3.04164C3.59854 4.02298 4.39295 4.81739 5.37429 4.81739C6.35563 4.81739 7.15005 4.02298 7.15005 3.04164C7.15005 2.0603 6.35563 1.26588 5.37429 1.26588Z"
                    fill="#1D4ED8"
                  ></path>
                  <path
                    d="M0.437329 9.9906L11.4377 9.9906C11.6732 9.9906 11.875 10.356 11.875 10.7823C11.875 11.2085 11.6732 11.5739 11.4377 11.5739L0.437329 11.5739C0.201844 11.5739 -3.19429e-08 11.2085 -6.92097e-08 10.7823C-1.06476e-07 10.356 0.201844 9.9906 0.437329 9.9906Z"
                    fill="#1D4ED8"
                  ></path>
                  <path
                    d="M16.0093 10.3508L18.3925 10.3508C18.7196 10.3508 19 10.6312 19 10.9583C19 11.2854 18.7196 11.5658 18.3925 11.5658L16.0093 11.5658C15.6821 11.5658 15.4018 11.2854 15.4018 10.9583C15.4018 10.6312 15.6354 10.3508 16.0093 10.3508Z"
                    fill="#1D4ED8"
                  ></path>
                  <path
                    d="M13.6257 7.96743C15.2613 7.96743 16.6165 9.32262 16.6165 10.9582C16.6165 12.5937 15.2613 13.9489 13.6257 13.9489C11.9901 13.9489 10.635 12.5937 10.635 10.9582C10.635 9.32262 11.9434 7.96743 13.6257 7.96743ZM13.6257 12.7339C14.607 12.7339 15.4015 11.9395 15.4015 10.9582C15.4015 9.97684 14.607 9.18242 13.6257 9.18242C12.6444 9.18242 11.8499 9.97684 11.85 10.9582C11.85 11.9395 12.6444 12.7339 13.6257 12.7339Z"
                    fill="#1D4ED8"
                  ></path>
                </svg>
              </span>{" "}
              Filters
            </button>
            <div id="filterBtn1" className="filter-content flex local-filter" ref={filterRef} onKeyDown={(e)=>{handleModalFocus(e)}}>
              <div className="flex wrap-dropdown">
                <div className="global-dropdown-block flex-center" id='project-status-id'>
                  <label>{translate("campaign_page.project_status")}</label>
                  <Select className="global-dropdown-select" classNamePrefix='cw'
                    value={status.filter(function (option) {
                      return option.value === projectStatus;
                    })}
                    aria-label="Project status"
                    options={status}
                    onChange={e => handleStatusChange(e)}
                    
                  />
                </div>
                <div className="global-dropdown-block flex-center">
                  <label>{translate("campaign_page.delivery_status")}</label>
                  <Select className="global-dropdown-select" classNamePrefix='cw'
                    value={deliveryStatus.filter(function (option) {
                      return option.value === projectDeliveryStatus;
                    })}
                    aria-label="Delivery status"
                    options={deliveryStatus}
                    onChange={e => handleDeliveryStatusChange(e)}
                    
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="projects-content">
          <div className="datatable-block project-table">
                  <DataTable
                    keyField="id"
                    columns={columns}
                    data={data}
                   // theme={theme}
                    defaultSortFieldId={1}
                    responsive
                    striped
                    selectableRowsHighlight={true}
                   // onSelectedRowsChange={handleChange}
                    pagination
                    onSort={handleSort}
                    pointerOnHover={true}
                    paginationServer
                    paginationTotalRows={totalRows}
                    onChangeRowsPerPage={handlePerRowsChange}
                    paginationRowsPerPageOptions={[10, 20, 40, 50, 100, 200]}
                    onChangePage={handlePageChange}
                    progressPending={projectDataLoader}
                    //progressComponent={""}
                    onRowClicked={(row) => {rowClicked(row)}}
                    noDataComponent={noDataFoundComponent()}
                  />
          </div>
        </div>
      </div>
      {selectRighModal ? 
      <>
      <div  className="overlay"></div>
      <ProjectDetailModal row_detail={projectDetail}/>
      </>
       : ''}
    </div>
  );
}
